import React from 'react';
import { StyledInputWrapper, TextInput } from "--floponents-web/atoms/TextInput";
import { InputGroup } from "--floponents-web/atoms/InputGroup";
import styled from 'styled-components';

const StyledInputGroup = styled(InputGroup)`
    & ${StyledInputWrapper} {
        padding: 0px;
    }
`

export const VerificationCodeInput: React.FC<{
    code: string,
    setCode: React.Dispatch<React.SetStateAction<string>>,
    enabled: boolean
    uiSize: "medium" | "large",
}> = props => {
    const { uiSize, code, setCode } = props
    const codeGroupRef = React.useRef<HTMLDivElement>(null);
    const inputs = React.useMemo(() => {
        return Array.from(codeGroupRef.current?.getElementsByTagName("input") || [])
    }, [codeGroupRef.current])


    if (props.code.length < 6)
        setCode(code.padEnd(6, " "))

    function focusInput(index: number) {
        inputs?.at(index)?.focus()
    }

    const updateCode = React.useCallback((e: React.ChangeEvent<HTMLInputElement>, val: string, pos: number) => {
        setCode(code.substring(0, pos) + (val.toUpperCase() || " ") + code.substring(pos + 1));
        if (!!e.target.value.length && pos < 5)
            inputs && inputs[pos + 1] && inputs[pos + 1]!.focus();
    }, [code, codeGroupRef.current])

    const onPaste = React.useCallback((pasteEvent: React.ClipboardEvent) => {
        pasteEvent.preventDefault();
        const inputs = codeGroupRef.current?.getElementsByTagName("input");
        let text = pasteEvent.clipboardData.getData('Text') // get plaintext clipboard contents
        if (!text.length || !inputs) return;
        const pasteLength = Math.min(text.length || inputs.length)
        const pastedCode = text.substring(0, pasteLength);
        setCode(pastedCode.toUpperCase());
        inputs[pasteLength - 1]!.focus();
    }, [])


    return <StyledInputGroup spacing={uiSize === "medium" ? 1 : 2} center ref={codeGroupRef}>
        <TextInput
            size={uiSize}
            width={52}
            align="center"
            disabled={!props.enabled}
            maxLength={1}
            value={code[0] != " " ? code[0] : ""}
            autoComplete="chrome-off"
            onBeforeInput={(e) => { e.currentTarget.value = '' }}
            onChange={(e, val) => updateCode(e, val, 0)}
            onPaste={onPaste} />
        <TextInput
            size={uiSize}
            width={52}
            align="center"
            disabled={!props.enabled}
            maxLength={1}
            value={code[1] != " " ? code[1] : ""}
            autoComplete="chrome-off"
            onKeyDown={e => {
                if (e.key == "Backspace" && !inputs.at(1)?.value)
                    focusInput(0)
            }}
            onBeforeInput={(e) => { e.currentTarget.value = '' }}
            onChange={(e, val) => updateCode(e, val, 1)} />
        <TextInput
            size={uiSize}
            width={52}
            align="center"
            disabled={!props.enabled}
            maxLength={1}
            value={code[2] != " " ? code[2] : ""}
            autoComplete="chrome-off"
            onKeyDown={e => {
                if (e.key == "Backspace" && !inputs.at(2)?.value)
                    focusInput(1)
            }}
            onBeforeInput={(e) => { e.currentTarget.value ? e.currentTarget.value = '' : null }}
            onChange={(e, val) => updateCode(e, val, 2)} />
        <TextInput
            size={uiSize}
            width={52}
            align="center"
            disabled={!props.enabled}
            maxLength={1}
            value={code[3] != " " ? code[3] : ""}
            autoComplete="chrome-off"
            onKeyDown={e => {
                if (e.key == "Backspace" && !inputs.at(3)?.value)
                    focusInput(2)
            }}
            onBeforeInput={(e) => { e.currentTarget.value = '' }}
            onChange={(e, val) => updateCode(e, val, 3)} />
        <TextInput
            size={uiSize}
            width={52}
            align="center"
            disabled={!props.enabled}
            maxLength={1}
            value={code[4] != " " ? code[4] : ""}
            autoComplete="chrome-off"
            onKeyDown={e => {
                if (e.key == "Backspace" && !inputs.at(4)?.value)
                    focusInput(3)
            }}
            onBeforeInput={(e) => { e.currentTarget.value = '' }}
            onChange={(e, val) => updateCode(e, val, 4)} />
        <TextInput
            size={uiSize}
            width={52}
            align="center"
            disabled={!props.enabled}
            maxLength={1}
            value={code[5] != " " ? code[5] : ""}
            autoComplete="chrome-off"
            onKeyDown={e => {
                if (e.key == "Backspace" && !inputs.at(5)?.value)
                    focusInput(4)
            }}
            onBeforeInput={(e) => { e.currentTarget.value = '' }}
            onChange={(e, val) => updateCode(e, val, 5)} />
    </StyledInputGroup>
}